import { useState, useRef, useEffect } from 'react';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var useKeyboardNavigation = function useKeyboardNavigation(items, select, close) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      highlightedItemIndex = _useState2[0],
      setHighlightedItemIndex = _useState2[1];

  var lastItemIndex = items.length;

  var calculateNextIndex = function calculateNextIndex() {
    return (highlightedItemIndex + 1) % lastItemIndex;
  };

  var calculatePreviousIndex = function calculatePreviousIndex() {
    return (lastItemIndex + (highlightedItemIndex - 1)) % lastItemIndex;
  };

  var onKeyDown = function onKeyDown(event) {
    var keyCode = event.keyCode;

    switch (keyCode) {
      case 38:
        // arrow up
        setHighlightedItemIndex(calculatePreviousIndex());
        event.preventDefault();
        break;

      case 40:
        // arrow down
        setHighlightedItemIndex(calculateNextIndex());
        event.preventDefault();
        break;

      case 13:
        // enter
        items[highlightedItemIndex] && select(items[highlightedItemIndex]);
        break;

      case 27:
        // escape
        close();
        setHighlightedItemIndex(0);
        break;
    }
  };

  return {
    onKeyDown: onKeyDown,
    setHighlightedItemIndex: setHighlightedItemIndex,
    highlightedItem: items[highlightedItemIndex]
  };
};

var useOnClickOutside = function useOnClickOutside(callback) {
  var targetRef = useRef(null);

  var clickOutsideOccurred = function clickOutsideOccurred(_ref) {
    var target = _ref.target;
    return targetRef.current && !targetRef.current.contains(target);
  };

  var clickOutsideHandler = function clickOutsideHandler(event) {
    return clickOutsideOccurred(event) && callback();
  };

  useEffect(function () {
    document.addEventListener('mousedown', clickOutsideHandler);
    return function () {
      return document.removeEventListener('mousedown', clickOutsideHandler);
    };
  });
  return {
    targetRef: targetRef
  };
};

var useDropdown = function useDropdown(items) {
  var initialSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = useState(initialSelection),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItem = _useState2[0],
      setSelectedItem = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var open = function open() {
    return setOpen(true);
  };

  var close = function close() {
    return setOpen(false);
  };

  var _useOnClickOutside = useOnClickOutside(close),
      targetRef = _useOnClickOutside.targetRef;

  var _useKeyboardNavigatio = useKeyboardNavigation(items, setSelectedItem, close),
      _onKeyDown = _useKeyboardNavigatio.onKeyDown,
      highlightedItem = _useKeyboardNavigatio.highlightedItem,
      setHighlightedItemIndex = _useKeyboardNavigatio.setHighlightedItemIndex;

  var resetHighlight = function resetHighlight() {
    return setHighlightedItemIndex(0);
  };

  useEffect(function () {
    close();
    resetHighlight();
  }, [selectedItem]);
  return {
    isVisible: items.length && isOpen,
    getWrapperProps: function getWrapperProps() {
      return {
        ref: targetRef
      };
    },
    getTriggerProps: function getTriggerProps() {
      return {
        onMouseDown: open,
        onFocus: open,
        onKeyDown: function onKeyDown(event) {
          return open() & _onKeyDown(event);
        }
      };
    },
    getItemProps: function getItemProps(item) {
      return {
        onMouseDown: function onMouseDown() {
          return setSelectedItem(item) & close() & resetHighlight();
        },
        onMouseEnter: function onMouseEnter() {
          return setHighlightedItemIndex(items.indexOf(item));
        }
      };
    },
    selectedItem: selectedItem,
    highlightedItem: highlightedItem
  };
};

export { useDropdown };
//# sourceMappingURL=index.es.js.map
